import React, { useEffect, useMemo, useState } from 'react';
import { browserHistory, Link } from 'react-router';
import moment from 'moment';
import { genericB2BAccountRequest } from '../../../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';

const DpmRequests = () => {
	const [status, setStatus] = useState('PENDING|LIMIT_EXCEEDED');
	const { registration } = useSelector(({ registration }) => ({ registration }));
	const dispatch = useDispatch();

	useEffect(() => {
		window.scrollTo(0, 0);
		dispatch(genericB2BAccountRequest(`requestType=userAccountDetails&fetchType=initiated,pending,limitExceeded`, null, true, true));
	}, []);

	const handleReview = (id, e) => {
		e.preventDefault();
		browserHistory.push(`/siteManagement/dpm-requests/${id}`);
	};

	const handleFilterChange = e => {
		setStatus(e.target.value);
	};

	const filteredRequests = useMemo(
		() =>
			registration.dpmRequests && registration.dpmRequests.responseObject
				? registration.dpmRequests.responseObject.filter(dpmRequest => status.split('|').includes(dpmRequest.status))
				: [],
		[registration.dpmRequests, status]
	);

	const handleRefresh = e => {
		e.preventDefault();
		dispatch(genericB2BAccountRequest(`requestType=userAccountDetails&fetchType=initiated,pending,limitExceeded`, null, true, true));
	};

	return (
		<div>
			<div className="smallPush">
				<h1 className="pageTitle">DPM Requests</h1>
			</div>
			<div className="flex justify-between items-center">
				<div>
					<label htmlFor="status">
						<b>Status:</b>
					</label>
					<select id="status" name="status" value={status} onChange={handleFilterChange} style={{ marginLeft: '.5rem' }}>
						<option value="PENDING|LIMIT_EXCEEDED">Pending</option>
						<option value="INITIATED">Initiated</option>
					</select>
				</div>
				<a href="" onClick={handleRefresh} style={{ textDecoration: 'none' }}>
					Refresh{' '}
					<span className="inline-block" style={{ transform: 'rotate(45deg)' }}>
						&#8635;
					</span>
				</a>
			</div>
			{filteredRequests.length > 0 ? (
				<React.Fragment>
					<div className="d-block d-sm-none">
						{filteredRequests.map((dpmRequest, index) => (
							<div key={dpmRequest.userIdTaxId + dpmRequest.accountNumber} className="p-2 border rounded" style={{ marginTop: '1rem' }}>
								<dl className="d-flex justify-content-between border-bottom">
									<dt>Request #</dt>
									<dd>{index + 1}</dd>
								</dl>
								<dl className="d-flex justify-content-between border-bottom">
									<dt>User ID</dt>
									<dd>{dpmRequest.userId}</dd>
								</dl>
								<dl className="d-flex justify-content-between border-bottom">
									<dt>Tax ID</dt>
									<dd>{dpmRequest.taxId}</dd>
								</dl>
								<dl className="d-flex justify-content-between border-bottom">
									<dt>Messages</dt>
									<dd>
										{dpmRequest.errorMessage ? (
											dpmRequest.errorMessage
												.split(';')
												.filter(Boolean)
												.map(errorMessage => (
													<React.Fragment key={errorMessage}>
														<span className="red">{errorMessage}</span>
														<br />
													</React.Fragment>
												))
										) : (
											<span>Awaiting Review</span>
										)}
									</dd>
								</dl>
								<dl className="d-flex justify-content-between border-bottom">
									<dt>Status</dt>
									<dd>{dpmRequest.status}</dd>
								</dl>
								<dl className="d-flex justify-content-between border-bottom">
									<dt>Date Submitted</dt>
									<dd>{moment(dpmRequest.submittedDate, ['MM:DD:YYYY[T]HH:mm:ss', moment.ISO_8601]).format('MM/DD/YYYY')}</dd>
								</dl>
								<dl className="d-flex justify-content-between border-bottom">
									<dt></dt>
									<dd>
										<a href="" onClick={handleReview.bind(this, dpmRequest.userIdTaxId + dpmRequest.accountNumber)}>
											Review
										</a>
									</dd>
								</dl>
							</div>
						))}
					</div>
					<div className="d-none d-sm-block">
						<div className="table-responsive">
							<table className="dataTable fullWidth">
								<thead>
									<tr>
										<th scope="col" style={{ whiteSpace: 'nowrap' }}>
											Request #
										</th>
										<th scope="col">User ID</th>
										<th scope="col">Tax ID</th>
										<th scope="col">Messages</th>
										<th scope="col">Status</th>
										<th scope="col">Date Submitted</th>
										<th scope="col">Review</th>
									</tr>
								</thead>
								<tbody>
									{filteredRequests.map((dpmRequest, index) => (
										<tr key={dpmRequest.userIdTaxId + dpmRequest.accountNumber}>
											<td>{index + 1}</td>
											<td>{dpmRequest.userId}</td>
											<td>{dpmRequest.taxId}</td>
											<td>
												{dpmRequest.errorMessage ? (
													dpmRequest.errorMessage
														.split(';')
														.filter(Boolean)
														.map(errorMessage => (
															<React.Fragment key={errorMessage}>
																<span className="red">{errorMessage}</span>
																<br />
															</React.Fragment>
														))
												) : (
													<span>Awaiting Review</span>
												)}
											</td>
											<td>{dpmRequest.status}</td>
											<td>{moment(dpmRequest.submittedDate, ['MM:DD:YYYY[T]HH:mm:ss', moment.ISO_8601]).format('MM/DD/YYYY')}</td>
											<td>
												<a href="" onClick={handleReview.bind(this, dpmRequest.userIdTaxId + dpmRequest.accountNumber)}>
													Review
												</a>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</React.Fragment>
			) : (
				<p className="text-center largePush">No Requests found</p>
			)}
			<p className="flex items-center justify-between">
				<Link to="/siteManagement">Back to Site Management</Link>
			</p>
		</div>
	);
};

export default DpmRequests;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/Dpm/dpmRequests.jsx